import React from "react";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

const localeText = {
  toolbarColumns: "עמודות",
  toolbarFilters: "סינון",
  toolbarDensity: "צפיפות",
  toolbarExport: "ייצוא",
  toolbarExportCSV: "ייצוא כ-CSV",
  toolbarExportPrint: "הדפסה",
  filterPanelTitle: "מסננים",
  filterOperatorContains: "מכיל",
  filterOperatorEquals: "שווה ל",
  filterOperatorStartsWith: "מתחיל ב",
  filterOperatorEndsWith: "מסתיים ב",
  filterOperatorIsEmpty: "ריק",
  filterOperatorIsNotEmpty: "לא ריק",
  filterOperatorIsAnyOf: "הוא אחד מ",
  columnsPanelTextFieldLabel: "חיפוש עמודה",
  columnsPanelHideAllButton: "הסתר הכל",
  columnsPanelShowAllButton: "הצג הכל",
  noRowsLabel: "אין נתונים", // ✅ תרגום No rows
  toolbarQuickFilterPlaceholder: "חיפוש...", // ✅ תרגום ל-Search
  footerRowSelected: (count: number) =>
    count === 1 ? "שורה אחת נבחרה" : `${count} שורות נבחרו`,
};

export interface DataGridCustomToolbarProps {
  editMode?: boolean;
  selectedCount?: number;
  onToggleEdit?: () => void;
  onOpenConfirm?: () => void;
  extraActions?: React.ReactNode;
  newRowValid?: boolean;
  newRowExists?: boolean;
  onSaveAndExit?: () => void;
}

const DataGridCustomToolbar: React.FC<DataGridCustomToolbarProps> = ({
  editMode,
  selectedCount,
  onToggleEdit,
  onOpenConfirm,
  extraActions,
  newRowValid,
  newRowExists,
  onSaveAndExit,
}) => {
  return (
    <GridToolbarContainer
      sx={{
        display: "flex",
        padding: 1,
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <GridToolbarQuickFilter />

      <Box sx={{ display: "flex", gap: 1 }}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "הנתונים שלי",
            utf8WithBom: true,
          }}
        />
        {/* כפתורים נוספים רק אם נשלחו */}
{onToggleEdit && (
  editMode && newRowExists && newRowValid ? (
    <Box display="flex" gap={1}>
      <Button
        startIcon={<SaveIcon sx={{ ml: 1 }} />}
        variant="contained"
        color="secondary"
        onClick={onSaveAndExit}
      >
        שמור וסגור
      </Button>
      <Button
        startIcon={<CloseIcon sx={{ ml: 1 }} />}
        variant="outlined"
        color="inherit"
        onClick={onToggleEdit}
      >
        סגור בלי לשמור
      </Button>
    </Box>
  ) : (
    <Button
      startIcon={<EditIcon sx={{ ml: 1 }} />}
      variant={editMode ? "contained" : "outlined"}
      color={editMode ? "primary" : "inherit"}
      onClick={onToggleEdit}
    >
      {editMode ? "סיים עריכה" : "ערוך"}
    </Button>
  )
)}


        {extraActions}
        {onOpenConfirm && (
          <Button
            startIcon={<DeleteIcon sx={{ ml: 1 }} />}
            variant="outlined"
            color="error"
            disabled={selectedCount === 0}
            onClick={onOpenConfirm}
          >
            מחק נבחרים
          </Button>
        )}
      </Box>
    </GridToolbarContainer>
  );
};

export { DataGridCustomToolbar,localeText };